// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderAddFilledSvg from "@fishx/icons-svg/es/asn/FolderAddFilled";
import FishxIcon from '../components/FishxIcon';

var FolderAddFilled = function FolderAddFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddFilledSvg
  }));
};

FolderAddFilled.displayName = 'FolderAddFilled';
export default React.forwardRef(FolderAddFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FolderAddFilled.js
// module id = 2798
// module chunks = 0